import { order, orderHelper } from '@functions/order-helper';
import { IHooksProps } from '../../types/ihooks.props';
import IService from '../../types/iservice';
import { PagedResponse } from '../../types/paged-response';
import { useEffect, useState } from 'react';

export abstract class AbstractHook<T, S extends Partial<IService<T>>> {
    protected props: IHooksProps<S>;

    constructor(props: IHooksProps<S>) {
        this.props = props;
    }

    getJson() {
        const [json, setJson] = useState<PagedResponse<T>>();
        const { page, limit, orderBy, orderDirection, filter, refresh, enabled } = this.props;

        useEffect(() => {
            if (enabled === false) return;
            this.fetchDependencies(setJson);
        }, [page, limit, orderBy, orderDirection, filter, refresh, enabled]);

        return { json };
    }

    protected async fetchDependencies(setJson: (data: PagedResponse<T>) => void) {
        let { service, filter, page, limit, orderBy, orderDirection } = this.props;
        const params = { currentPage: page + 1, recordsPerPage: limit };

        if (orderBy) {
            const orderArray = orderBy.split('&');
            
            const orderObject = orderArray.reduce<order>((acc, field) => {
                acc[field]= orderDirection.toUpperCase();
                return acc;
            }, {});
            
            filter = filter + (filter === '' ? '?' : '&') + orderHelper(orderObject);
        }
        try {
            const response = await service.getAll(filter, params);
            setJson(response.data);
        } catch (e) {
            console.error(e);
        }
    }
}
